export function Divider() {
  return <div className="app-divider" />;
}
